import { sendJsonToApi } from './apiHelper';

/**
 * RixEngine API requires JWT. sendJsonToApi sends the token; fetchDataFromApi does not.
 * We normalize the response to the same shape other reports get: array of { key, value }.
 */
function toFieldsArray(responseData) {
    if (!responseData) return [];
    const arr = Array.isArray(responseData) ? responseData : Object.entries(responseData).map(([k, v]) => ({ key: k, value: v }));
    return arr.map((item, index) => ({ key: String(index), value: item }));
}

export const fetchRixEngineCompareDataFields = async () => {
    try {
        const response = await sendJsonToApi('post', '/api/rixengine/compare/getdatafields', {});
        return toFieldsArray(response?.data);
    } catch (_) {
        return [];
    }
};

export const fetchRixEngineCompareStatisticFields = async () => {
    try {
        const response = await sendJsonToApi('post', '/api/rixengine/compare/getstatfields', {});
        return toFieldsArray(response?.data);
    } catch (_) {
        return [];
    }
};

export const fetchRixEngineCompareDimensions = async () => {
    try {
        const response = await sendJsonToApi('post', '/api/rixengine/compare/getdimensions', {});
        return toFieldsArray(response?.data);
    } catch (_) {
        return [];
    }
};

/**
 * Available report fields for RixEngine Companies (column keys and labels).
 * Keys must match backend CompaniesReportService::ALLOWED_FIELDS.
 */
export const RIX_ENGINE_COMPANIES_FIELDS = [
    { key: 'partner_id', label: 'Partner ID' },
    { key: 'partner_name', label: 'Partner Name' },
    { key: 'type_desc', label: 'Type' },
    { key: 'update_time', label: 'Update Time' },
    { key: 'advertisers_count', label: 'Advertisers' },
    { key: 'publishers_count', label: 'Publishers' },
    { key: 'advertisers', label: 'Advertisers (Buyers)' },
    { key: 'publishers', label: 'Publishers (Sellers)' },
];

/**
 * Fetch RixEngine companies (partners with advertisers and publishers) for the Companies report.
 * @param {{ fields?: string[] }} options - Optional. fields: list of field keys to return; empty/omitted = all.
 */
export const fetchRixEngineCompanies = async (options = {}) => {
    try {
        const body = {};
        if (options.fields != null && Array.isArray(options.fields) && options.fields.length > 0) {
            body.fields = options.fields;
        }
        const response = await sendJsonToApi('post', '/api/rixengine/companies/get', body);
        return Array.isArray(response?.data) ? response.data : [];
    } catch (_) {
        return [];
    }
};
